<template>
    <div @click="handleClick">
      <div class="bg-moone-off-white hover:bg-gray-50 shadow-md rounded-full p-2 transition-colors flex items-center justify-center">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="currentColor" fill="none">
            <path d="M15 6C15 6 9.00001 10.4189 9 12C8.99999 13.5812 15 18 15 18" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'BackButton',
    props: {
      to: {
        type: [String, Object],
        default: null
      }
    },
    methods: {
      handleClick() {
        if (this.to) {
          this.$router.push({name:this.to})
        } else {
          this.$router.back()
        }
      }
    }
  }
  </script>